<template>
  <div :class="viewMode" :id="searchableId">
    <ModelHeaderSmall :model="model" :post="element" :showChat="showChat" v-if="showHeader" />

    <Carousel 
      v-if="showCarousel"
      :postData="postData"
      :postContent="postContent"
      :model="model"
      :VideoElementHandler="VideoElementHandler"
    />
    <Simple 
      v-else
      :postData="postData"
      :postContent="postContentSimple"
      :model="model"
      :VideoElementHandler="VideoElementHandler"
      :viewMode="viewMode"
      @changeMode="changeMode"
      @enableModal="enableModal"
    />

    <Description :post="element" :model="model" v-if="showDescription" />

    <ModalSorter 
      v-if="showModal"
      :element="element" 
      :model="model" 
      :VideoElementHandler="VideoElementHandler"
      :showChat="showChat" 
      @close="showModal = false"
    />

  </div>
</template>
<script>
import Description from "./Description.vue";
import Carousel from "./Carousel.vue";
import Simple from "./Simple.vue";
import ModelHeaderSmall from "./ModelHeaderSmall.vue";

import ModalSorter from "./ModalSorter.vue";

export default {
  name: "PostSorter",
  components: {
    Description,
    ModelHeaderSmall,
    Carousel,
    Simple,
    ModalSorter,
  },
  props: {
    element: {},
    changeViewMode: {},
    model: {},
    showChat: {
      type: Boolean,
      default: false,
      required: false,
    },
    viewMode: {
      type: String,
      default: "vertical",
      required: false,
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  methods: {
    changeMode() {
      if (this.changeViewMode) {
        this.changeViewMode(this.searchableId);
      }
    },
    enableModal() {
      if (this.viewMode === "grid") {
        this.showModal = true;
      }
    },
  },
  computed: {
    isCarousel() {
      return this.element && this.element.content && this.element.content.length > 1;
    },
    showCarousel() {
      return this.isCarousel && this.viewMode !== "grid";
    },
    postContent() {
      if (this.element.content) {
        return this.element.content;
      }

      return this.element;
    },
    postData() {
      // Duplicate thos.element
      const data = { ...this.element };

      if (data.content) {
        if (data.content.length) {
          data.qElements = data.content.length;
        } else {
          data.qElements = 1;
        }

        delete data.content;
      }

      return data;
    },
    postContentSimple() {
      const data = this.element.content;

      if (data) {
        return data[0];
      }

      return this.element;
    },
    VideoElementHandler() {
      return this.$parent;
    },
    showDescription() {
      return this.viewMode !== "grid";
    },
    showHeader() {
      return this.viewMode !== "grid";
    },
    searchableId() {
      return `post-${this.element.post_id}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.grid {
  width: 100%;
  height: 100%;
}
</style>
